<template>
    <div id="post">
        <div class="row align-space-between">
            <p style="font-size: 28px; font-weight: bold">{{ title }}</p>
            <div class="row" style="gap:16px">
                <v-select 
                    v-if="hasFile == 1"
                    style="border:1px solid black; "
                    v-model="selectFilename" 
                    :items="fileOptions" 
                    base-color="white" 
                    bg-color="white" 
                    color="white" 
                    item-title="title" 
                    item-value="value" 
                    item-color="gray" 
                    :max-width="400" 
                    width="300" 
                    return-object 
                    :hide-details="true" 
                ></v-select>
            
                <button style="height: 58px; width:58px" @click="
                        content ?  checkNotice =true : downloadFile()">
                    <TrayArrowDown :size="30" ></TrayArrowDown>
                </button>
            </div>
        </div>
        <div class="row align-space-between" style="margin-top: 16px">
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ category }}
            </p>
            <p style="font-size: 20px; font-weight: normal; color: #5f5f5f">
                {{ downloadDate }}
            </p>
        </div>
    </div>
    <v-dialog v-if="content!=null" v-model="checkNotice" persistent max-width="600px">
        <v-card>
            <v-card-title class="headline" style="font-weight:bold; color:#ff7c7c">주의</v-card-title>

            <v-card-text>
                <div v-html="safeHtml"></div>
            </v-card-text>

            <v-card-actions class="d-flex justify-end">
                <v-btn color="grey" @click="checkNotice = false">취소</v-btn>
                <v-btn color="primary" @click="
                downloadFile();
                checkNotice = false
                ">받기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import TrayArrowDown from "vue-material-design-icons/TrayArrowDown.vue";
import DOMPurify from "dompurify";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "",
        },
        content: {
            type: String,
            default: null,
        },
        date: {
            type: String,
            default: "",
        },
        filename: {
            type: String,
            default: "",
        },
        hasFile: {
            type: Boolean,
            default: false,
        },
        url : {
            type: String,
            default: "",
        },
        onClick: Function,
    },
    components: {
        TrayArrowDown,
    },
    setup(props) {
        const store = useStore();
        const downloadDate = ref("");
        const checkNotice = ref(false);
        const fileNames = ref([]);
        const selectFilename = ref("");
        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        const downloadFile = () => {
            if (props.hasFile) {
                const file = selectFilename.value
                store.dispatch("getFileDownload", file.value);
            } else {
                window.open(props.url, "_blank");
            }
        };

        const safeHtml = computed(() => {
            const detail = props.content.replace(/\n/g, "<br>");
            return DOMPurify.sanitize(detail, {
                ADD_TAGS: ["iframe"], // iframe 태그 추가
            });
        });

        const fileOptions = computed(() => {
            return fileNames.value.map(filename => ({
                title: filename,
                value: filename
            }))
        })



        onMounted(() => {
            downloadDate.value = formatKoreanDate(props.date)
            fileNames.value = (props.filename || '').split(',')
            
            selectFilename.value = {
                title: fileNames.value[0],
                value: fileNames.value[0]
            }
        })
        return { formatKoreanDate, downloadFile, downloadDate, safeHtml, checkNotice, fileOptions, selectFilename };
    },
});
</script>

<style scoped>
button {
    padding: 8px;
    border: 0.5px solid #b0b0b0;
}

#post {
    width: 100%;
    padding: 16px 24px;
    border-bottom: 1px solid #b3b3b3;
    cursor: pointer;
}
</style>
